var React = require('react');

function Textarea (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"æä¼¸ 1","opacity":"0.2","clipPath":"url(#clip0_627_2300)","key":0},React.createElement("path",{"id":"Vector","d":"M19.0055 12.3304L20.42 13.7449L13.349 20.8159L11.9345 19.4014L19.0055 12.3304ZM16.102 2.73488L17.516 4.14887L3.37396 18.2904L1.95996 16.8764L16.102 2.73438V2.73488Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_627_2300"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Textarea.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Textarea;

Textarea.default = Textarea;
